module.exports = __webpack_public_path__ + "img/questionMark.d8c86ab3.png";